import React from 'react';
import { Link } from 'react-router-dom';

import './button.scss';

const ButtonOne = () => {
  return (
        <Link to='/login' className="btn-action">
            Log Out
        </Link>
  );
}

export default ButtonOne;